import { css } from '@emotion/css';
import { Popup } from 'Shared/forms/Popup';


const POPUP_BACKGROUND = '#222';
const TITLE_BACKGROUND  = '#2a2a2a';

const colourPatchStyle = () => css({
	margin:       '0 0.2em 0.5em',
	border:       'solid 1px #444',
	borderRadius: '2em',
	height:       '2em',
});


export function ColourPickerPopup(P: { value?: string | null, close: () => void, children: any })
{
	return (
		<Popup moveable close={P.close} background={POPUP_BACKGROUND} titleBackground={TITLE_BACKGROUND}>
			<div class={colourPatchStyle()} style={{ 'background-color': P.value ?? undefined }} />
			{P.children}
		</Popup>
	);
}
